import {useState,useEffect} from "react";
import Select from "react-select";
/* -- biz9 import start -- */
import FormNoData from '../../../formNoData';
import {Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image} from "biz9-portal-app";
import {Log,Str} from "biz9-utility";
/* -- biz9 import end -- */
/* -- DEFINE --
 * --- ABOUT ---
 * dashboard-edit-item-custom-fields
*/
const Item_Custom_Field_Edit = (props) => {
    const [formNoDataShow, setFormNoDataShow] = useState(true);
    const [val_note,setValueNote] =  useState("");
    useEffect(() => {
    },[props]);
    const updateCustomField = (event) => {
        let item_custom_update = JSON.parse(event.value);
        props.item[item_custom_update.field] = item_custom_update.value;
        props.onItemUpdate(props.item,item_custom_update.field,item_custom_update.value);
    };

    const handle_submit = (event) => {
        event.preventDefault();
    };
    return (
            <div className="settings-card">
            <div className="settings-card-head bg-light">
            <h4>{Str.get_table_by_name(Portal_Table.CUSTOM_FIELD,{plural:true})}</h4> </div>
            <form onSubmit={handle_submit}>
            <div className="settings-card-body">
            <div className="row">
            {props.custom_fields.length<=0 && <FormNoData/>}
            {props.custom_fields.map((item) => (
                        <div className="col-md-8">
                        <div className="form-wrap">
                        <label className="form-label mb-1 fw-medium text-dark">
                        {Str.get_capital_first_letter(item.title)}
            </label>
 <Select
     classNamePrefix="react-select"
      options={item.items}
      onChange={updateCustomField}
      placeholder={item.selected}
    />

                        </div>
                        </div>
                        ))}
            </div>
            </div>
            </form>
            </div>
            );
};
export default Item_Custom_Field_Edit;
